<template>
  <nav id="mmenu" class="mm-menu mm-theme-white mm-offcanvas mm-right mm-front mm-current mm-opened">
    <div class="mm-panels">
      <div class="mmDiv mm-panel mm-hasnavbar mm-opened mm-current" id="mm-0">
        <div class="mm-navbar"><a class="mm-title">网站导航</a></div>
<!--        <div class="MMhead"> <a href="#mm-0" @click="$emit('close',false)" class="closemenu noblock">x</a> <a href="javascript:;" target="_blank"-->
<!--            class="noblock"><i class="fa fa-weibo"></i></a> <a href="javascript:;" target="_blank" class="noblock"><i-->
<!--              class="fa fa-tencent-weibo"></i></a>-->
<!--          &lt;!&ndash;<a href="" target="_blank" class="noblock">English</a>&ndash;&gt;-->
<!--        </div>-->
<!--        <div class="mm-search">-->
<!--          <form class="mm-search-form" name="formsearch" action="/plus/search.php">-->
<!--            <input type="hidden" name="kwtype" value="0">-->
<!--            <input type="text" autocomplete="off" value="" name="q" class="side-mm-keyword" placeholder="输入关键字...">-->
<!--          </form>-->
<!--        </div>-->
        <ul class="mm-listview">
<!--          <li class="m-Lev1"><a href="">网站首页</a></li>-->
<!--          <li class="m-Lev1"> <a href="a/about/index.html" class="m-menu1">关于我们</a></li>-->
<!--          <li class="m-Lev1"> <a href="a/case/index.html" class="m-menu1">成功案例</a></li>-->
<!--          <li class="m-Lev1"><a href="a/news/index.html" class="m-menu1">新闻资讯</a></li>-->
<!--          <li class="m-Lev1"> <a href="a/lianxiwomen/index.html" class="m-menu1">联系我们</a></li>-->
          <li class="m-Lev1"><a href="index.html">网站首页</a></li>
          <li class="m-Lev1"> <a href="about.html" class="m-menu1">关于我们</a></li>
          <li class="m-Lev1"> <a href="zwzl.html" class="m-menu1">植物租赁</a></li>
          <li class="m-Lev1"> <a href="fwxm.html" class="m-menu1">服务项目</a></li>
          <li class="m-Lev1"> <a href="product.html" class="m-menu1">成功案例</a></li>
          <li class="m-Lev1"> <a href="article.html?articleCategoryId=5" class="m-menu1">新闻动态</a></li>
          <li class="m-Lev1"> <a href="article.html?articleCategoryId=6" class="m-menu1">养护知识</a></li>
          <li class="m-Lev1"> <a href="contact.html" class="m-menu1">联系我们</a></li>
          <li class="m-Lev1"> <a href="https://baibuzb.taobao.com" target="_blank" class="m-menu1">网络商城</a></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
/**
*@fileName nav.vue
*@author ylf
@description
*@date 2025/07/22 20:37:24
*/

export default {
  components: {
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {

  },
  mounted () {

  },
  methods: {

  },
  destroyed () { }
}
</script>

<style lang='scss' scoped>
@import '@/mixins/_utils.scss';
</style>
<style lang="scss">
.mm-menu.mm-right {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999;
}

.mm-menu {
  height: 100vh;
  background-color: #fff;
  width: 80%;
  min-width: 140px;
  max-width: 440px;
}

.mm-panels>.mm-panel {
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
  padding: 0 20px;
}

.mm-navbar {
  text-align: center;
}
#mmenu .MMhead{
  border-top: 1px #E5E5E5 solid;
}
#mmenu a {
  padding: 10px 10px 10px 20px;
  color: #333;
  font-size: 14px;
  border-color: inherit;
 }
 .mm-navbar-title {
  font-size: 14px;
  font-weight: 400;
  color: #333;
}
</style>
